import { isArray } from '../../utils/isArray/isArray';
import { isEmpty } from '../../utils/isEmpty/isEmpty';
/**
 * Logger is a utility that adds wrapper around browser Console API.
 * @class
 */
export class Logger {
    prefix = '';
    constructor(options) {
        if (typeof options?.prefix === 'string') {
            this.prefix = options.prefix;
        }
    }
    log = (level, title, args) => {
        const message = [];
        if (this.prefix) {
            message.push(`[${this.prefix}]`);
        }
        message.push(title);
        if (isArray(args) && !isEmpty(args)) {
            args.forEach((data) => {
                message.push('\n\n');
                message.push(data);
            });
        }
        // eslint-disable-next-line no-console
        console[level]?.(...message);
    };
    /**
     * Add information message into console.
     *
     * @method
     * @name Logger#info
     * @param {unknown} title Title of message.
     * @param {unknown[]} messages Other information, You can pass array or several messages split by comma.
     */
    info = (title, ...messages) => {
        this.log('info', title, messages);
    };
    /**
     * Add warning message into console.
     *
     * @method
     * @name Logger#warn
     * @param {unknown} title Title of message.
     * @param {unknown[]} messages Other information, You can pass array or several messages split by comma.
     */
    warn = (title, ...messages) => {
        this.log('warn', title, messages);
    };
    /**
     * Add message as table into console.
     *
     * @method
     * @name Logger#table
     * @param {unknown[]} data Messages as array or as object.
     */
    table = (data) => {
        // eslint-disable-next-line no-console
        console.table(data);
    };
    /**
     * Add error message into console.
     *
     * @method
     * @name Logger#error
     * @param {unknown} title Title of message, You can pass string or Error object.
     * @param {unknown[]} messages Other information, You can pass array or several messages split by comma.
     */
    error = (title, ...messages) => {
        /*
         * If pass Error object, we split it to message and stacktrace,
         * it helps us show stacktrace correctly, otherwise we will see only message
         * */
        if (title instanceof Error || title.message) {
            this.log('error', title.message, [title, ...messages]);
            return;
        }
        this.log('error', title, messages);
    };
    /**
     * Set prefix for all messages when you call any logger method.
     *
     * @method
     * @name Logger#setPrefix
     * @param {string} prefix Title of message, You can pass string or Error object.
     *
     * @example
     * // All messages will have prefix "[MyModule]" in console
     * logger.setPrefix('MyModule');
     */
    setPrefix(prefix) {
        this.prefix = prefix;
    }
    /**
     * Allow to configure logger by passing set of options.
     *
     * @method
     * @name Logger#configure
     * @param {LoggerOptions} options Set of options to configure logger.
     */
    configure(options) {
        if (typeof options?.prefix === 'string') {
            logger.setPrefix(options.prefix);
        }
    }
}
export const logger = new Logger();
